module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/mg-app-shell/',
  octopusPackageId: 'my-garage-app-shell',
  octopusProjectName: 'My Garage App Shell',
  mountDOMId: '__mg-app-shell__',
  standalone: false
};